<template>
  <section id="header">
    <div class="container">
      <prismic-link class="logo" :field="prismic_data.site_logo_link">
        <prismic-image :field="prismic_data.site_logo" />
      </prismic-link>
    </div>
    <div
      class="hero"
      :style="[windowSize > 768 ? { backgroundImage: 'url(' + prismic_data.hero_section_image.url + ')' } : { backgroundImage: 'url(' + prismic_data.hero_section_image_mobile.url + ')' }, {backgroundColor: prismic_data.hero_section_background_color}]"
    >
      <div class="container inner-hero">
        <div class="content">
          <h1>{{prismic_data.page_title[0].text}}</h1>
          <button
            class="button-primary"
            v-scroll-to="'#meme-generator'"
          >{{prismic_data.button_one_text}}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeaderSection",
  props: {
    prismic_data: {
      type: Object,
      required: true,
    },
    windowSize: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#header {
  .logo {
    display: inline-block;
    margin-bottom: 40px;
    vertical-align: middle;
    max-width: 378px;
    @media (max-width: $breakpoint-sm) {
      margin: 16px 0 16px 16px;
      max-width: initial;
    }
    img {
      display: block;
      @media (max-width: $breakpoint-sm) {
        width: 140px;
      }
    }
  }

  .hero {
    height: 568px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    @media (max-width: $breakpoint-sm) {
      height: 643px;
      background-position: center bottom;
    }

    .inner-hero {
      display: flex;
      height: 100%;
    }

    .content {
      flex-basis: 50%;
      align-self: center;

      @media (max-width: $breakpoint-md) {
        flex-basis: 65%;
      }

      @media (max-width: $breakpoint-sm) {
        flex-basis: 100%;
        align-self: flex-start;
        margin-top: 50px;
        padding: 0 16px;
      }
    }

    h1 {
      line-height: 56px;
      color: $color-white;
      letter-spacing: 1px;
      @media (max-width: $breakpoint-sm) {
        line-height: 46px;
      }
    }

    .button-primary {
      padding: 16px 40px;
      margin-top: 38px;
      @media (max-width: $breakpoint-md) {
        font-size: 16px;
        padding: 16px 34px;
      }
      @media (max-width: $breakpoint-sm) {
        font-size: 12px;
        width: 100%;
        padding: 14px 28px;
      }
    }
  }
}
</style>